import { lazy, ComponentProps, ReactNode } from 'react';

export type AssetsSubFolderType = 'dboo' | 'docTypes' | 'homeChoiceFaq';
type IconProps = {
  name: string;
  subFolder?: AssetsSubFolderType;
  qaSelector?: string;
  fallback?: ReactNode;
};

export type LazySvgProps = ComponentProps<'svg'> & IconProps;

const subFolderMap: Record<AssetsSubFolderType, string> = {
  dboo: 'dboo',
  docTypes: 'document-types',
  homeChoiceFaq: 'home-choice-faq',
};

export function lazyImport({ name, subFolder }: IconProps) {
  const lazyIcon = lazy(async () => {
    // Lookup order: common/<subFolder>/ → common/images-multicolor/ → common/
    if (subFolder) {
      try {
        return await import(
          `../../assets/common/${subFolderMap[subFolder]}/${name}.svg?react`
        );
      } catch {
        /* fall through */
      }
    }
    try {
      return await import(
        `../../assets/common/images-multicolor/${name}.svg?react`
      );
    } catch {
      return import(`../../assets/common/${name}.svg?react`);
    }
  });

  return lazyIcon;
}
